/**
 * @readonly
 * @enum {string}
 */
export const State = {
  Open: 'open',
  Closed: 'closed',
};